<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <Processors />
    </div>
</template>

<script>
import currentUserQuery from '@views/Processors/Browse/queryCurrentUser.graphql';

import Processors from '../Processors/Browse.vue';

export default {
  name: 'ProcessorsContainer',
  components: {
    Processors,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['developer', 'admin'].includes(this.currentUser.role.name);

      if (!validRole) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
};
</script>
